<template>
  <div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style lang="less" >
@import '~@/assets/styles/reset.less';
@import '~@/assets/styles/icon.less';

</style>
